import(/* webpackMode: "eager" */ "/vercel/path0/app/globals.css");
;
import(/* webpackMode: "eager" */ "/vercel/path0/components/AdSenseFacade.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/components/AnalyticsInitializer.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/components/DeferredScripts.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ErrorBoundary"] */ "/vercel/path0/components/ErrorBoundary.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/components/ErrorMonitorInitializer.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/components/Navigation.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["NavigationFallback"] */ "/vercel/path0/components/NavigationFallback.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/components/PerformanceMonitor.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/components/ResourcePreloader.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/components/RouteProgress.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/components/ServiceWorkerInitializer.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/components/ThemeInitializer.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Toaster"] */ "/vercel/path0/components/ui/sonner.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/link.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/shared/lib/lazy-dynamic/dynamic-bailout-to-csr.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/shared/lib/lazy-dynamic/preload-css.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/font/google/target.css?{\"path\":\"app/layout.tsx\",\"import\":\"Inter\",\"arguments\":[{\"subsets\":[\"latin\"],\"display\":\"swap\",\"preload\":true}],\"variableName\":\"inter\"}");
